import { serverItems, Servers } from '@constants/server';
import { FormControl, InputLabel, Select, MenuItem, SelectProps } from '@mui/material';

export const ServerNameSelector = ({
  value,
  onChange,
  disabled,
  required = false,
}: {
  value: string;
  onChange: SelectProps['onChange'];
  disabled?: boolean;
  required?: boolean;
}) => {
  return (
    <FormControl required variant="outlined" className="text-field">
      <InputLabel id="serviceName">Service Name</InputLabel>
      <Select
        labelId="serviceName"
        value={value}
        onChange={onChange}
        label="Service Name"
        name="serviceName"
        disabled={disabled}
        required={required}
      >
        {serverItems.map((item) => {
          return (
            <MenuItem key={item.value} value={item.value}>
              {item.name}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};
